var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.view}},[_c('i',{staticClass:"fa el-icon-edit"})])}
var staticRenderFns = []

export { render, staticRenderFns }